export class Steps {
    public static DateSelection: number = 0;
    public static AreaSelection: number = 1;
    public static GroupSelection: number = 2;
    public static TicketSelection: number = 3;
    public static ShowBasket: number = 4;
    public static InvoiceData: number = 5;
    public static Summary: number = 6;
}
